<script>
import AllThatApplyQuestion from "./QuestionTypes/AllThatApplyQuestion.vue"
import MultipleChoiceQuestion from "./QuestionTypes/MultipleChoiceQuestion.vue"
import TrueFalseQuestion from "./QuestionTypes/TrueFalseQuestion.vue"
import YesNoQuestion from "./QuestionTypes/YesNoQuestion.vue"
import axios from "axios";
import {useModal} from "../../../composables/useModal";

export default {
    name: "question",
    components: {
        AllThatApplyQuestion,
        MultipleChoiceQuestion,
        TrueFalseQuestion,
        YesNoQuestion
    },
    computed: {
        questionHandle() {
            return this.question.safeHandle + "-question"
        }
    },
    data() {
        return {
            answeredCorrect: false,
        }
    },
    methods: {
        checkInput(input) {
            const self = this
            if (input === null) {
                const {showModal} = useModal();
                showModal({
                    title: 'Error',
                    message: 'Please select an answer',
                    buttonClass: 'btn btn-light-grey text-secondary d-inline-block mx-auto',
                })
                return;
            }
            const formData = new FormData()
            formData.append("input", input)
            axios.post(self.question.urls.checkAnswer, formData)
                .then(response => {
                    self.showMessage(response.data)

                    self.answeredCorrect = response.data.data.correct
                    self.$emit('question-answered', {
                        questionID: self.question.id,
                        correct: response.data.data.correct,
                        quizProgress: response.data.data.quizProgress,
                        continueToNextQuestion: response.data.data.continueToNextQuestion
                    })
                })
                .catch(error => {
                    console.error(error)
                    alert(error.response.data.message);
                })
        },
        showMessage(responseData) {
            const self = this
            const {showModal} = useModal()
            if (responseData.data.quizProgress.data.complete) {
                // show the complete message if they completed the quiz
                // should this be a 2nd modal or should the content for their 
                // last answer show first followed by the complete quiz message
            }

            const {correct, quizProgress, message, continueToNextQuestion} = responseData.data

            let buttonText = (correct || continueToNextQuestion) ? 'Next Question' : 'Try again'
            if (quizProgress.data.complete) {
                buttonText = 'Close'
            }

            const icon = correct ?
                '<div class="icon-wrapper"><i class="bi bi-check2 text-success fs-1"></i></div>' :
                '<div class="icon-wrapper"><i class="bi bi-x-circle text-danger fs-1"></i></div>'

            showModal({
                icon: icon,
                message: message,
                buttonText: buttonText,
                buttonClass: 'btn btn-light-grey text-secondary d-inline-block mx-auto',
                onClose: () => {
                    self.$emit('answer-modal-closed')
                }
            })
        }
    },
    props: {
        question: {
            type: Object,
            required: true
        }
    }
}
</script>

<template>
    <div class="mb-3" v-if="question.meta.display">
        <p class="mb-2">{{ question.title }}</p>
        <p v-if="question.content">{{ question.content }}</p>
        <component
            :is="questionHandle"
            :question="question"
            @checkInput="checkInput"
        ></component>
    </div>
</template>

